import axios from 'axios';

const api = axios.create({
    baseURL: 'https://viacep.com.br/ws/',
});

export const handlerSearchCEP = async (cep) => {
    try {
        const response = await api.get(`${cep}/json/`);
        return response.data || null;
    }
    catch (error) {
        return null;
    }
};

export default api;